import React from "react";
import { UnderlineTabs, UnderlineTabItem } from "component/shared/underline-tabs";

export type SearchSettingsTab = "experience" | "results";

const TABS: UnderlineTabItem<SearchSettingsTab>[] = [
	{ value: "experience", label: "Search Experience" },
	{ value: "results", label: "Search Results" },
];

interface Props {
	value: SearchSettingsTab;
	onChange: (value: SearchSettingsTab) => void;
}

export const SearchSettingsTabs: React.FC<Props> = ({ value, onChange }) => (
	<UnderlineTabs aria-label="Search settings" tabs={TABS} value={value} onChange={onChange} />
);
